// extracted by mini-css-extract-plugin
export default {"crumbs":"nui-LqCBPfVZ","item":"nui-wkQX6vlj"};